import { useDropzone } from 'react-dropzone';
import { Typography } from '../../../base-components';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto'; //TODO: Fix Add Photo icon
import ErrorFile from '../Previews/ErrorFile';
import AvatarPreview from '../Previews/AvatarPreview';
import { IUploadProps } from '../FormUploadFile.interfaces';
import { StyledDropZone, StyledPlaceholder } from './UploadAvatar.styles';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const UploadAvatar = (props: IUploadProps) => {
    const { t } = useTranslation();
    const { error, file, disabled, helperText, sx, ...other } = props;
    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragReject,
        fileRejections,
    } = useDropzone({
        multiple: false,
        disabled,
        ...other,
    });

    const hasFile = !!file;

    const isError = isDragReject || !!error;

    return (
        <>
            <StyledDropZone
                {...getRootProps()}
                sx={{
                    ...(isDragActive && {
                        opacity: 0.72,
                    }),
                    ...(isError && {
                        borderColor: 'error.light',
                        ...(hasFile && {
                            bgcolor: 'error.light',
                        }),
                    }),
                    ...(disabled && {
                        opacity: 0.48,
                        pointerEvents: 'none',
                    }),
                    ...(hasFile && {
                        '&:hover': {
                            '& .placeholder': {
                                opacity: 1,
                            },
                        },
                    }),
                    ...sx,
                }}
            >
                <input {...getInputProps()} />

                {hasFile && <AvatarPreview file={file} />}

                <StyledPlaceholder
                    className="placeholder"
                    sx={{
                        '&:hover': {
                            opacity: 0.72,
                        },
                        ...(hasFile && {
                            zIndex: 9,
                            opacity: 0,
                            color: 'common.white',
                            backgroundColor: (theme) =>
                                alpha(theme.palette.grey[900], 0.64),
                        }),
                        ...(isError && {
                            color: 'error.main',
                            backgroundColor: 'error.light',
                        }),
                    }}
                >
                    <AddAPhotoIcon />

                    <Typography variant="caption">
                        {file
                            ? t('uploadFile.updatePhoto')
                            : t('uploadFile.uploadPhoto')}
                    </Typography>
                </StyledPlaceholder>
            </StyledDropZone>

            {helperText && helperText}

            <ErrorFile fileRejections={fileRejections} />
        </>
    );
};

export default UploadAvatar;
